import React, {FC}                 from "react";
import {Button}                    from "@sirius/ui-lib/src/blocks/Controls";
import {HBox}                      from "@sirius/ui-lib/src/blocks/Layout";
import {SortFilterClearPopupType}  from "./@types";
import {block}                     from "./block";

const clearPopupWidth = 40;
export const SortFilterClearPopup: FC<SortFilterClearPopupType> = ({
    name,
    offset,
    target,
    hide,
    hold,
    clearColSortFilter,
    rowWidth
}) => {
    const { clientWidth, offsetParent } = target;

    const calcLeft =
        offset + clientWidth + clearPopupWidth > rowWidth
            ? offset - (clearPopupWidth + 4)
            : offset + clientWidth + 4
    ;
    const targetParentHeight = offsetParent?.clientHeight;

    const popupStyle = {
        left:   calcLeft,
        height: targetParentHeight
    };

    return  <HBox
                className    = {block.el('sort-filter-clear-popup-wrapper')}
                onMouseOver  = {(e)=> {e.stopPropagation(); hold()}}
                onMouseLeave = {(e)=> {e.stopPropagation(); hide()}}
            >
                <HBox
                    className = {block.el('sort-filter-clear-popup')}
                    style     = {popupStyle}
                >
                    <Button
                        className = {block.el('sort-filter-clear-popup-button')}
                        icon      = {'clear'}
                        size      = {'xs'}
                        onAction  = {clearColSortFilter}
                    />
                </HBox>
            </HBox>
    ;
};
